/* Karta — 1 karta = 1 téma (DESIGN-PRAVIDLA §5). Karta v kartě je zakázaná.
 *   <Karta testid="karta-cile">
 *     <Karta.Hlavicka nazev="Cíle" info="…" akce={<Button size="sm">…</Button>} />
 *     <Karta.Telo>…</Karta.Telo>
 *   </Karta>
 * Karta:          as ("section" výchozí | "div" | "article"), className, testid, ...rest
 * Karta.Hlavicka: nazev (povinné, <h2> text-base), info (text InfoTipu), infoObsah, akce, uroven (2|3), testid
 * Karta.Telo:     className, children
 * Vzhled: --surface, --line, --radius, --shadow-card, p-4 mobil / p-5 desktop.
 */
import InfoTip from "@/components/ui/InfoTip";

function Karta({ as: Tag = "section", className = "", testid, children, ...rest }) {
  return (
    <Tag
      data-testid={testid}
      className={`rounded-[var(--radius)] border border-[var(--line)] bg-[var(--surface)] p-4 text-[var(--ink)] shadow-[var(--shadow-card)] md:p-5 ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

function Hlavicka({ nazev, info, infoObsah, akce, uroven = 2, testid }) {
  const H = uroven === 3 ? "h3" : "h2";
  return (
    <div data-testid={testid} className="mb-3 flex min-h-[28px] items-center gap-2">
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <H className="min-w-0 truncate text-base font-semibold text-[var(--ink)]">{nazev}</H>
        {info || infoObsah ? (
          <span className="inline-flex items-center px-1">
            <InfoTip nazev={nazev} text={info} testid={testid ? `${testid}-info` : "info-tip"}>{infoObsah}</InfoTip>
          </span>
        ) : null}
      </div>
      {akce ? <div className="flex shrink-0 items-center gap-2">{akce}</div> : null}
    </div>
  );
}

function Telo({ className = "", children }) {
  return <div className={`text-sm ${className}`}>{children}</div>;
}

Karta.Hlavicka = Hlavicka;
Karta.Telo = Telo;

export { Hlavicka as KartaHlavicka, Telo as KartaTelo };
export default Karta;
